<!-- Start: pf_unified missing code: 17-06-2026 -->
<template>
    <div class="employee-tab-inner">
        <div class="row no-gutters py-2 mb-3 border-bottom">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title">
                    <h4 class="clearfix">
                        <span class="float-left">Migrated PF History</span> 
                        <template v-if="fdata.lock == 0">
                            <button class="btn btn-block btn-secondary tab-button"  @click="update_mpf()">{{ button_title }}</button>
                        </template>
                    </h4>
                </div>
                <div class="ibox-content">
                    <b-form @submit.stop.prevent="onSubmit">                    
                        <div class="clearfix">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <b-form-group id="closing_balance_date-group" label="Closing Balance Date" class="required-field"
                                        label-for="closing_balance_date">
                                        <b-input-group>
                                            <b-form-input id="closing_balance_date" name="closing_balance_date" :disabled="is_disable" v-model="fdata.closing_balance_date"
                                                v-validate="{ required: true,date_format:'yyyy-MM-dd'}" :state="validateState('closing_balance_date')" type="text" placeholder="YYYY-MM-DD"
                                                autocomplete="off" ata-vv-as="Closing Balance Date"></b-form-input>
                                                
                                            <b-input-group-append>
                                                <b-form-datepicker :disabled="is_disable" id="closing_balance_date" button-only right locale="en-US"
                                                        v-model="fdata.closing_balance_date"></b-form-datepicker>
                                            </b-input-group-append>
                                            <b-form-invalid-feedback id="closing_balance_date-feedback">{{
                                                veeErrors.first('closing_balance_date')}}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div> 
                                <div class="col-6"> 
                                    <b-form-group  id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                                        <b-input-group>
                                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" v-validate="{ required: true }" :options="fiscal_years" :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback" data-vv-as="Fiscal Year" :disabled="is_disable" class="radius-8"></b-form-select>
                                            <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div> 
                            </div>
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <b-form-group id="membership_month-group" label="PF Membership Tenure (Months)"
                                        class="required-field" label-for="membership_month">
                                        <b-form-input id="membership_month" name="membership_month"
                                            v-model="fdata.membership_month" :disabled="is_disable"
                                            v-validate="{ required: true,regex: '^\\d+$'}"
                                            :state="validateState('membership_month')"
                                            aria-describedby="membership_month-feedback"
                                            data-vv-as="Membership Tenure"></b-form-input>
                                        <b-form-invalid-feedback id="membership_month-feedback">{{
                                            veeErrors.first('membership_month')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group id="service_month-group" label="Service Tenure (Months)"
                                        class="required-field" label-for="service_month">
                                        <b-form-input id="service_month" name="service_month"
                                            v-model="fdata.service_month" :disabled="is_disable"
                                            v-validate="{ required: true,regex: '^\\d+$'}"
                                            :state="validateState('service_month')"
                                            aria-describedby="service_month-feedback"
                                            data-vv-as="Service Tenure"></b-form-input>
                                        <b-form-invalid-feedback id="service_month-feedback">{{
                                            veeErrors.first('service_month')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="employer_contribution-group" label="Employer's Contribution" class="required-field"
                                            label-for="employer_contribution" >
                                            <b-form-input id="employer_contribution" :disabled="is_disable" name="employer_contribution" :value="formatMoney(fdata.employer_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="employer_contribution-group" label="Employer's Contribution" class="required-field"
                                            label-for="employer_contribution">
                                            <b-form-input id="employer_contribution" name="employer_contribution" v-model="fdata.employer_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('employer_contribution')"
                                                aria-describedby="employer_contribution-feedback"
                                                data-vv-as="Employer Contribution"></b-form-input>
                                            <b-form-invalid-feedback id="employer_contribution-feedback">{{
                                                veeErrors.first('employer_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                    
                                </div>
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="employee_contribution-group" label="Employee's Contribution" class="required-field"
                                            label-for="employee_contribution" >
                                            <b-form-input id="employee_contribution" :disabled="is_disable" name="employee_contribution" :value="formatMoney(fdata.employee_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="employee_contribution-group" label="Employee's Contribution" class="required-field"
                                            label-for="employee_contribution">
                                            <b-form-input id="employee_contribution" name="employee_contribution" v-model="fdata.employee_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('employee_contribution')"
                                                aria-describedby="employee_contribution-feedback"
                                                data-vv-as="Employee Contribution"></b-form-input>
                                            <b-form-invalid-feedback id="employee_contribution-feedback">{{
                                                veeErrors.first('employee_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                            </div>

                            <!-- Start: Profit -->
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="profit_employer_contribution-group" label="Employer's Contribution (Profit)" class="required-field"
                                            label-for="profit_employer_contribution" >
                                            <b-form-input id="profit_employer_contribution" :disabled="is_disable" name="profit_employer_contribution" :value="formatMoney(fdata.profit_employer_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="profit_employer_contribution-group" label="Employer's Contribution" class="required-field"
                                            label-for="profit_employer_contribution">
                                            <b-form-input id="profit_employer_contribution" name="profit_employer_contribution" v-model="fdata.profit_employer_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('profit_employer_contribution')"
                                                aria-describedby="profit_employer_contribution-feedback"
                                                data-vv-as="Employer's Contribution (Profit)"></b-form-input>
                                            <b-form-invalid-feedback id="profit_employer_contribution-feedback">{{
                                                veeErrors.first('profit_employer_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                    
                                </div>
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="profit_employee_contribution-group" label="Employee's Contribution (Profit)" class="required-field"
                                            label-for="profit_employee_contribution" >
                                            <b-form-input id="profit_employee_contribution" :disabled="is_disable" name="profit_employee_contribution" :value="formatMoney(fdata.profit_employee_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="profit_employee_contribution-group" label="Employee's Contribution (Profit)" class="required-field"
                                            label-for="profit_employee_contribution">
                                            <b-form-input id="profit_employee_contribution" name="profit_employee_contribution" v-model="fdata.profit_employee_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('profit_employee_contribution')"
                                                aria-describedby="profit_employee_contribution-feedback"
                                                data-vv-as="Employee's Contribution (Profit)"></b-form-input>
                                            <b-form-invalid-feedback id="profit_employee_contribution-feedback">{{
                                                veeErrors.first('profit_employee_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                            </div>
                            <!-- End: Profit -->

                            <!-- Start: Forfeiture -->
                             <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="forfeiture_employer_contribution-group" label="Employer's Contribution (Forfeiture)" class="required-field"
                                            label-for="forfeiture_employer_contribution" >
                                            <b-form-input id="forfeiture_employer_contribution" :disabled="is_disable" name="forfeiture_employer_contribution" :value="formatMoney(fdata.forfeiture_employer_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="forfeiture_employer_contribution-group" label="Employer's Contribution (Forfeiture)" class="required-field"
                                            label-for="forfeiture_employer_contribution">
                                            <b-form-input id="forfeiture_employer_contribution" name="forfeiture_employer_contribution" v-model="fdata.forfeiture_employer_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('forfeiture_employer_contribution')"
                                                aria-describedby="forfeiture_employer_contribution-feedback"
                                                data-vv-as="Employer's Contribution (Forfeiture)"></b-form-input>
                                            <b-form-invalid-feedback id="forfeiture_employer_contribution-feedback">{{
                                                veeErrors.first('forfeiture_employer_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                    
                                </div>
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="forfeiture_employee_contribution-group" label="Employee's Contribution (Forfeiture)" class="required-field"
                                            label-for="forfeiture_employee_contribution" >
                                            <b-form-input id="forfeiture_employee_contribution" :disabled="is_disable" name="forfeiture_employee_contribution" :value="formatMoney(fdata.forfeiture_employee_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="forfeiture_employee_contribution-group" label="Employee's Contribution (Forfeiture)" class="required-field"
                                            label-for="forfeiture_employee_contribution">
                                            <b-form-input id="forfeiture_employee_contribution" name="forfeiture_employee_contribution" v-model="fdata.forfeiture_employee_contribution"
                                                v-validate="{ required: true,regex: '^[0-9]*[.]?[0-9]+$',min:1 }" :state="validateState('forfeiture_employee_contribution')"
                                                aria-describedby="forfeiture_employee_contribution-feedback"
                                                data-vv-as="Employee's Contribution (Forfeiture)"></b-form-input>
                                            <b-form-invalid-feedback id="forfeiture_employee_contribution-feedback">{{
                                                veeErrors.first('forfeiture_employee_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                            </div>
                            <!-- End: Forfeiture -->

                            <!-- Start: Fiscal Year Specific Migrated Balance for Tax -->
                            <div class="row mt-3 px-2 border-top pt-3">
                                <div class="col-12">
                                    <h5 class="text-primary font-weight-bold">Fiscal Year Migrated Portion (For Tax Calculation)</h5>
                                </div>
                            </div>
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="fy_employer_contribution-group" label="Employer's Contribution (FY Portion)" label-for="fy_employer_contribution">
                                            <b-form-input id="fy_employer_contribution" :disabled="is_disable" name="fy_employer_contribution" :value="formatMoney(fdata.fy_employer_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="fy_employer_contribution-group" label="Employer's Contribution (FY Portion)" label-for="fy_employer_contribution">
                                            <b-form-input id="fy_employer_contribution" name="fy_employer_contribution" v-model="fdata.fy_employer_contribution"
                                                v-validate="{ regex: '^[0-9]*[.]?[0-9]+$' }" :state="validateState('fy_employer_contribution')"
                                                aria-describedby="fy_employer_contribution-feedback"
                                                data-vv-as="FY Employer Contribution"></b-form-input>
                                            <b-form-invalid-feedback id="fy_employer_contribution-feedback">{{ veeErrors.first('fy_employer_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="fy_employee_contribution-group" label="Employee's Contribution (FY Portion)" label-for="fy_employee_contribution">
                                            <b-form-input id="fy_employee_contribution" :disabled="is_disable" name="fy_employee_contribution" :value="formatMoney(fdata.fy_employee_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="fy_employee_contribution-group" label="Employee's Contribution (FY Portion)" label-for="fy_employee_contribution">
                                            <b-form-input id="fy_employee_contribution" name="fy_employee_contribution" v-model="fdata.fy_employee_contribution"
                                                v-validate="{ regex: '^[0-9]*[.]?[0-9]+$' }" :state="validateState('fy_employee_contribution')"
                                                aria-describedby="fy_employee_contribution-feedback"
                                                data-vv-as="FY Employee Contribution"></b-form-input>
                                            <b-form-invalid-feedback id="fy_employee_contribution-feedback">{{ veeErrors.first('fy_employee_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                            </div>
                            <div class="row mt-2 px-2">
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="fy_profit_employer_contribution-group" label="Employer's Profit (FY Portion)" label-for="fy_profit_employer_contribution">
                                            <b-form-input id="fy_profit_employer_contribution" :disabled="is_disable" name="fy_profit_employer_contribution" :value="formatMoney(fdata.fy_profit_employer_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="fy_profit_employer_contribution-group" label="Employer's Profit (FY Portion)" label-for="fy_profit_employer_contribution">
                                            <b-form-input id="fy_profit_employer_contribution" name="fy_profit_employer_contribution" v-model="fdata.fy_profit_employer_contribution"
                                                v-validate="{ regex: '^[0-9]*[.]?[0-9]+$' }" :state="validateState('fy_profit_employer_contribution')"
                                                aria-describedby="fy_profit_employer_contribution-feedback"
                                                data-vv-as="FY Employer Profit"></b-form-input>
                                            <b-form-invalid-feedback id="fy_profit_employer_contribution-feedback">{{ veeErrors.first('fy_profit_employer_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                                <div class="col-6">
                                    <template v-if="is_disable">
                                        <b-form-group id="fy_profit_employee_contribution-group" label="Employee's Profit (FY Portion)" label-for="fy_profit_employee_contribution">
                                            <b-form-input id="fy_profit_employee_contribution" :disabled="is_disable" name="fy_profit_employee_contribution" :value="formatMoney(fdata.fy_profit_employee_contribution)"></b-form-input>
                                        </b-form-group>
                                    </template>
                                    <template v-else>
                                        <b-form-group id="fy_profit_employee_contribution-group" label="Employee's Profit (FY Portion)" label-for="fy_profit_employee_contribution">
                                            <b-form-input id="fy_profit_employee_contribution" name="fy_profit_employee_contribution" v-model="fdata.fy_profit_employee_contribution"
                                                v-validate="{ regex: '^[0-9]*[.]?[0-9]+$' }" :state="validateState('fy_profit_employee_contribution')"
                                                aria-describedby="fy_profit_employee_contribution-feedback"
                                                data-vv-as="FY Employee Profit"></b-form-input>
                                            <b-form-invalid-feedback id="fy_profit_employee_contribution-feedback">{{ veeErrors.first('fy_profit_employee_contribution') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>
                            </div>
                            <!-- End: Fiscal Year Specific Migrated Balance for Tax -->

                            <div class="row mt-2 px-2">
                                <div class="col-12 mt-3 text-center">
                                    <b-button v-if="is_disable == false" @click="onSubmit"  type="submit" variant="primary" class="">Save</b-button>
                                </div>
                            </div>
                           
                        </div>
                    </b-form>
                </div>
                
            </div>
        </div>
     
            
       
    
    </div>
    
</template>
<script>
    import moment from 'moment';

    export default{
        
        mounted() {
            
            this.permission = this.$acl['employee/mpfh'];
        },
        props: ['pageurl' , 'flg'],
        data(){            
            return {                
                is_disable:true,
                // fdata:{id:0,employer_contribution:0,employee_contribution:0,distributed_profit:0,distributed_forfeiture:0,closing_balance_date:null,membership_month:0,service_month:0,lock:0},
                fdata:{id:0,employer_contribution:0,employee_contribution:0,profit_employer_contribution:0,profit_employee_contribution:0,forfeiture_employer_contribution:0,forfeiture_employee_contribution:0,fy_employer_contribution:0,fy_employee_contribution:0,fy_profit_employer_contribution:0,fy_profit_employee_contribution:0,closing_balance_date:null,membership_month:0,service_month:0,lock:0,fiscal_year:''},
                permission:0,
                button_title:"Update PF History",
                showoverlay:false,
                fiscal_years: this.$fiscal_year_options,
            }
        },
        methods:{
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            }, 
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                         
                //this.showMessage();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                   
                    let formData = new FormData();
                    
                   
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);  
                    } 

                    axios.post(this.$api_url+'/pf/migrate/save', formData)
                            .then(function (response) 
                            {
                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                this.showoverlay = false;
                                this.$validator.reset();  
                                // this.mpf_details();   
                                // this.update_mpf();
                                
                                this.reset_form();
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                                
                            });
                });
            },
            reset_form: function()
            {
                this.fdata = 
                {
                    id:0,
                    employer_contribution:0,
                    employee_contribution:0,
                    profit_employer_contribution: 0,
                    profit_employee_contribution: 0,
                    forfeiture_employer_contribution: 0,
                    forfeiture_employee_contribution: 0,
                    fy_employer_contribution: 0,
                    fy_employee_contribution: 0,
                    fy_profit_employer_contribution: 0,
                    fy_profit_employee_contribution: 0,
                    closing_balance_date:null,
                    membership_month:0,
                    service_month:0,
                    lock:0,
                    fiscal_year:'',
                };

                
            },
            update_mpf:function()
            {
                if(this.is_disable)
                {
                    this.is_disable = false;
                    this.button_title = "Close Update";
                }
                else
                {
                    this.is_disable = true; 
                    this.button_title = "Update PF History";
                }
                
            },
            mpf_details()
            {

                if(!this.checkNet()) return false;    
                axios.get(this.$api_url+'/pf/migrate/details' , {
                    params: {
                        
                    }
                }).then(function(response){
                  this.fdata = response.data;
                    
                  if(this.fdata.id == 0)
                  {
                    this.reset_form();
                  }
                  
                }.bind(this));
            },

        },
        created: function(){
            this.mpf_details();
        }
    }
</script>
<!-- End: pf_unified missing code: 17-06-2026 -->
